import { render, staticRenderFns } from "./LogCos.vue?vue&type=template&id=736e6a71&scoped=true"
import script from "./LogCos.vue?vue&type=script&lang=js"
export * from "./LogCos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736e6a71",
  null
  
)

export default component.exports